import {Lightning} from "@lightningjs/sdk"
import { Base, ButtonSmall, TextBox } from "@lightningjs/ui-components"
import { Helper } from "../../../helper"
import EPGUtility from "../epg-utility"

export default class EPGTimelineUI extends Base {
    [x: string]: any

    static get __componentName(): string {
        return 'EPGTimelineUI'
    }

    static get tags() {
        return []
    }

    static get properties() {
        return ['startDate', 'index', 'channelIndex']
    }

    _update(){
        const halfHour = new Date(this.st)
        halfHour.setMinutes(30)
        this.patch({
            Background1: {
                w:this.finalW,
                h:this.finalH,
                rect:true,
                color: this._isFocused ? 0xffffffff : 0xff222222,
                zIndex:1,
                children: [
                    {
                        x: 0,
                        y: 0,
                        w:this.finalW,
                        h:this.finalH,
                        rect: true,
                        color: 0x00000000,
                        shader: {
                            type: Lightning.shaders.RoundedRectangle,
                            radius: 0,
                            stroke: 1,
                            strokeColor: 0xff999999
                        }
                    },
                    {
                        zIndex:2,
                        type: TextBox,
                        fixed: true,
                        w:this.w,
                        content: EPGUtility.formatAMPM(this.st),
                        style: {
                            offsetY: 20,
                            textStyle: {
                                fontSize: 26,
                                fontFace: Helper.getFontFamily('Light'),
                                textColor: Helper.getHexaColor('ffffff'),
                                maxLines: 1,
                                maxLinesSuffix: '...'    
                            }
                        }
                    }
                ]
            }
        })
    }

    override getFocusScale() {
        return 1
    }
}
